/* eslint-disable react-hooks/exhaustive-deps */
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useReactiveVar } from "@apollo/client";
import { Button, Form, Modal, Radio, Table, message, UploadFile } from "antd";
import {
  PlusOutlined,
  PlayCircleFilled,
  CheckCircleFilled,
  QuestionCircleFilled,
} from "@ant-design/icons";
import type { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import Player from "@vimeo/player";
import "./GoGoLive.css";

import GoGoLiveCreateDrawer from "./components/GoGoLiveCreateDrawer";
import GoGoLiveEditDrawer from "./components/GoGoLiveEditDrawer";
import OpenHouseCreateDrawer from "./components/OpenHouseCreateDrawer";
import OpenHouseEditDrawer from "./components/OpenHouseEditDrawer";
import TEV2Drawer from "./components/TEV2Drawer";
import { GGLDataType, DataType, TEV2DataType, RadioOption } from "./content/GoGoLiveType";

import { ServiceTypes } from "../../../types/types";
import { Colors } from "../../../constants/Colors";
import { useGetUserProgramsByServiceQuery } from "../../../graphql/operations/get-user-program-by-service";
import { __currentUser__ } from "../../../graphql/policies";
import { renderDecodedId } from "../../../utils/renderDecodedId";
import NoPermission from "../../../components/others/NoPermission";
import Spinner from "../../../components/layout/spinner/Spinner";
import { data } from "../../../data/data";
import GeneralModal from "../../../utils/GeneralModal";
//import { useGetGglDataQuery } from "../../../graphql/operations/get-ggl-data";
import { useGoGoLiveParentGuideListQuery } from "../../../graphql/operations/clubApp/ves/get-gogolive-parent-guide-list";
import { useGetOpenHouseDataQuery } from "../../../graphql/operations/clubApp/ves/get-open-house-data";
import { useDeleteGoGoLiveParentGuideMutation } from "../../../graphql/operations/clubApp/ves/delete-parent-guide";
import { useCreateGoGoLiveMutation } from "../../../graphql/operations/clubApp/ves/create-ggl";
import { useDeleteGoGoLiveMutation } from "../../../graphql/operations/clubApp/ves/delete-ggl";
import { useUpdateGoGoLiveMutation } from "../../../graphql/operations/clubApp/ves/update-ggl";
import { useGetTev2MonthlySongListQuery } from "../../../graphql/operations/clubApp/TEV2/getTev2MonthlySongList";
import { useDeleteTev2MonthlySongMutation } from "../../../graphql/operations/clubApp/TEV2/deleteTev2MonthlySong";
import { useUploadFileMutation } from "../../../graphql/operations/upload-file";
import { AfBlobPath } from "../../../graphql/operations/@types";
import { renderAntDMessageConfig } from "../../../utils/renderAntDMessageConfig";

interface GoGoLiveProps {
  setSelectedService: Dispatch<SetStateAction<ServiceTypes>>;
  setSelectSubItem: Dispatch<SetStateAction<string | undefined>>;
}

const { capFilters } = data;

const GoGoLive = ({ setSelectedService, setSelectSubItem }: GoGoLiveProps) => {
  const currentUser = useReactiveVar(__currentUser__);
  const [selectType, setSelectType] = useState("ggla");
  const [options, setOprions] = useState<RadioOption[]>([]);
  const [tabColumns, setTabColumns] = useState<any>();
  const [tabData, setTabData] = useState<any>();
  const [displayGglData, setDisplayGglData] = useState<GGLDataType[]>([]);
  const [displayOhData, setDisplayOhData] = useState<DataType[]>([]);
  const [displayTEData, setDisplayTEData] = useState<TEV2DataType[]>([]);
  const [displayCAPKData, setDisplayCAPKData] = useState<GGLDataType[]>([]);
  const [displayFAFUData, setDisplayFAFUData] = useState<GGLDataType[]>([]);
  const [displayPLYTData, setDisplayPLYTData] = useState<GGLDataType[]>([]);
  const [showPreview, setShowPreview] = useState(false);
  const [selectPreview, setSelectPreview] = useState<
    GGLDataType | DataType | TEV2DataType | any
  >();
  const [showGGLEditDrawer, setShowGGLEditDrawer] = useState(false);
  const [showGGLCreateDrawer, setShowGGLCreateDrawer] = useState(false);
  const [showDeleteGGLModal, setShowDeleteGGLModal] = useState(false);
  const [toBeDeletedGGL, setToBeDeletedGGL] = useState<
    GGLDataType | undefined
  >();
  const [showOhEditDrawer, setShowOhEditDrawer] = useState(false);
  const [showOhCreateDrawer, setShowOhCreateDrawer] = useState(false);
  const [tEV2DrawerOpen, setTEV2DrawerOpen] = useState(false);
  const [showDeleteTev2Modal, setShowDeleteTev2Modal] = useState(false);
  const [toBeDeletedTev2, setToBeDeletedTev2] = useState<
    TEV2DataType | undefined
  >();
  const [selectGGLVideo, setSelectGGLVideo] = useState<GGLDataType | undefined | null>();
  const [selectVideo, setSelectVideo] = useState<DataType | undefined | null>();
  const [selectedTEV2Video, setSelectedTEV2Video] = useState<TEV2DataType>();
  const [isCreate, setIsCreate] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<UploadFile>();
  const [hkPdfFileName, setHkPdfFileName] = useState<
    string | undefined | null
  >();
  const [krPdfFileName, setKrPdfFileName] = useState<
    string | undefined | null
  >();
  const [twPdfFileName, setTwPdfFileName] = useState<
    string | undefined | null
  >();
  const [posterFileName, setPosterFileName] = useState<
    string | undefined | null
  >();
  const vimeoRef = useRef<any>();
  const navigate = useNavigate();
  const [gglCreateForm] = Form.useForm();
  const [ohCreateForm] = Form.useForm();
  const [gglEditForm] = Form.useForm();
  const [ohEditForm] = Form.useForm();
  const {
    data: userPrograms,
    loading: userProgramsLoading,
    error: userProgramsError,
  } = useGetUserProgramsByServiceQuery({
    variables: {
      userId: parseInt(renderDecodedId(currentUser?.id)),
      serviceId: 2,
    },
  });
  const {
    data: gglData,
    loading: gglDataLoading,
    error: gglDataError,
    refetch: gglRefetch,
  } = useGoGoLiveParentGuideListQuery({
    variables: { serviceType: selectType.toUpperCase() },
    fetchPolicy: "network-only",
  });
  const {
    data: ohData,
    loading: ohDataLoading,
    error: ohDataError,
    refetch: ohRefetch,
  } = useGetOpenHouseDataQuery({
    variables: { startDate: dayjs().startOf("year").subtract(1, "year") },
  });
  const {
    data: TEV2Data,
    loading: TEV2DataLoading,
    error: TEV2DataError,
    refetch: TEV2Refetch,
  } = useGetTev2MonthlySongListQuery();

  const [createGGL, { loading: createLoading }] = useCreateGoGoLiveMutation();
  const [updateGGL, { loading: updateLoading }] = useUpdateGoGoLiveMutation();
  const [deleteGGL, { loading: deleteLoading }] = useDeleteGoGoLiveMutation();
  const [deleteGGLParentGuide] = useDeleteGoGoLiveParentGuideMutation();
  const [deleteTev2MonthlySong] = useDeleteTev2MonthlySongMutation();
  const [uploadFile] = useUploadFileMutation();

  const onCancel = () => {
    const player = new Player(vimeoRef.current);
    player.pause();
    setShowPreview(false);
    setSelectPreview(null);
  };

  const handlePreviewClick = (record: any) => {
    setShowPreview(true);
    setSelectPreview(record);
  };

  const handleGGLEditClick = (record: GGLDataType) => {
    setSelectGGLVideo(record);
    navigate(`/club-app/ves/${record.id}/detail`);
  };

  const handleGGLDelete = (id: number) => {
    deleteGGLParentGuide({
      variables: {
        goGoLiveParentGuideId: id,
      },
    }).then(() => {
      message.success("Successfully deleted");
      closeDeleteGGLModal();
      gglRefetch();
    });
  };

  const closeDeleteGGLModal = () => {
    setShowDeleteGGLModal(false);
    setToBeDeletedGGL(undefined);
  };



  const handleEditClick = (record: DataType) => {
    setUploadedFile(undefined);
    setSelectVideo(record);
    //if (selectType === "ggl") {
    //  setShowGGLEditDrawer(true);
    //} else {
    setShowOhEditDrawer(true);
    //}
  };

  const handleDelete = (record: DataType) => {
    setSelectVideo(record);
    deleteGGL({ variables: { GGLIds: record.seq?.map((seq) => ({ seq })) } })
      .then(() => {
        setSelectVideo(undefined);
        message.success(
          renderAntDMessageConfig("Delete Go, Go Live! content successful.")
        );
        //if (selectType === "ggl") {
        //  gglRefetch().catch((e) => console.log(e));
        //} else {
        ohRefetch().catch((e) => console.log(e));
        //}
      })
      .catch((e) => console.log(e));
  };

  const handleTEV2Delete = (seq: number) => {
    deleteTev2MonthlySong({
      variables: {
        seq: seq,
      },
    }).then(() => {
      message.success("Successfully deleted");
      closeDeleteTev2Modal();
      TEV2Refetch();
    });
  };

  const closeDeleteTev2Modal = () => {
    setShowDeleteTev2Modal(false);
    setToBeDeletedTev2(undefined);
  };

  const gglColumns: ColumnsType<GGLDataType> = [
    {
      title: "Year month",
      dataIndex: "yearMonth",
      key: "yearMonth",
      render: (value: string) => dayjs(value).format("YYYY-MMM"),
      sorter: (a: GGLDataType, b: GGLDataType) =>
        dayjs(a.yearMonth).valueOf() - dayjs(b.yearMonth).valueOf(),
    },
    {
      title: "CAP level",
      dataIndex: "capLevel",
      key: "capLevel",
      filters: capFilters,
      onFilter: (value: any, record: any) =>
        record.capLevel.indexOf(value) === 0,
      sorter: (a: any, b: any) => a.capLevel?.localeCompare(b.capLevel),
    },
    {
      title: "Video",
      dataIndex: "vimeoId",
      key: "vimeoId",
      render: (value: string, record: GGLDataType) =>
        value ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            <PlayCircleFilled
              style={{ marginRight: 8, fontSize: 20, cursor: "pointer" }}
              onClick={() => handlePreviewClick(record)}
            />
            <p>{value}</p>
          </div>
        ) : (
          <p style={{ color: "rgba(0,0,0,0.25)" }}>N/A</p>
        ),
    },
    //{
    //  title: "Parent's guide",
    //  render: (_, record: DataType) => (
    //    <div className="ggl-preview-container">
    //      <div className="ggl-preview-inner-container">
    //        HK
    //        {record.fileNameHK ? (
    //          <CheckCircleFilled className="guide-icon" />
    //        ) : (
    //          <QuestionCircleFilled className="guide-icon-not-exist" />
    //        )}
    //      </div>
    //      <div className="ggl-preview-inner-container">
    //        KR
    //        {record.fileNameKR ? (
    //          <CheckCircleFilled className="guide-icon" />
    //        ) : (
    //          <QuestionCircleFilled className="guide-icon-not-exist" />
    //        )}
    //      </div>
    //      <div className="ggl-preview-inner-container">
    //        TW
    //        {record.fileNameTW ? (
    //          <CheckCircleFilled className="guide-icon" />
    //        ) : (
    //          <QuestionCircleFilled className="guide-icon-not-exist" />
    //        )}
    //      </div>
    //    </div>
    //  ),
    //},
    //{
    //  title: "Poster",
    //  dataIndex: "fileNamePoster",
    //  key: "fileNamePoster",
    //  render: (value: string | null | undefined) => (
    //    <div className="ggl-preview-container">
    //      <div className="ggl-preview-inner-container">
    //        {value ? "Done" : "Undone"}
    //        {value ? (
    //          <CheckCircleFilled className="guide-icon" />
    //        ) : (
    //          <QuestionCircleFilled className="guide-icon-not-exist" />
    //        )}
    //      </div>
    //    </div>
    //  ),
    //},
    {
      title: "Action",
      dataIndex: "",
      key: "",
      width: 100,
      render: (_, record: GGLDataType) => (
        <div style={{ display: "flex" }}>
          <Button
            type="link"
            style={{ padding: 0, marginRight: 16 }}
            onClick={() => handleGGLEditClick(record)}
          >
            {record.yearMonth && !dayjs(record.yearMonth).isBefore(dayjs(), "month")
              ? "Edit"
              : "View"}
          </Button>
          {record.yearMonth && !dayjs(record.yearMonth).isBefore(dayjs(), "month") && (
            <Button
              type="link"
              style={{ padding: 0 }}
              onClick={() => {
                if (record.id) {
                  setShowDeleteGGLModal(true);
                  setToBeDeletedGGL(record);
                }
              }}
              loading={deleteLoading && record.id === selectGGLVideo?.id}
            >
              Delete
            </Button>
          )}
        </div>
      ),
    },
  ];

  const ohColumns: ColumnsType<DataType> = [
    {
      title: "Year month",
      dataIndex: "yearMonth",
      key: "yearMonth",
      render: (value: string) => dayjs(value).format("YYYY-MMM"),
      sorter: (a: DataType, b: DataType) =>
        dayjs(a.yearMonth).valueOf() - dayjs(b.yearMonth).valueOf(),
    },
    {
      title: "Video",
      dataIndex: "vimeoId",
      key: "vimeoId",
      render: (value: string, record: DataType) =>
        value ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            <PlayCircleFilled
              style={{ marginRight: 8, fontSize: 20, cursor: "pointer" }}
              onClick={() => handlePreviewClick(record)}
            />
            <p>{value}</p>
          </div>
        ) : (
          <p style={{ color: "rgba(0,0,0,0.25)" }}>N/A</p>
        ),
    },
    {
      title: "Parent's guide",
      render: (_, record: DataType) => (
        <div className="ggl-preview-container">
          <div className="ggl-preview-inner-container">
            {record.fileNameHK ? "Done" : "Undone"}
            {record.fileNameHK ? (
              <CheckCircleFilled className="guide-icon" />
            ) : (
              <QuestionCircleFilled className="guide-icon-not-exist" />
            )}
          </div>
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "",
      key: "",
      width: 100,
      render: (_, record: DataType) => (
        <div style={{ display: "flex" }}>
          <Button
            type="link"
            style={{ padding: 0, marginRight: 16 }}
            onClick={() => handleEditClick(record)}
          >
            Edit
          </Button>
          <Button
            type="link"
            style={{ padding: 0 }}
            onClick={() => handleDelete(record)}
            loading={deleteLoading && record.id === selectVideo?.id}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  const TEColumns: ColumnsType<TEV2DataType> = [
    {
      title: "Year month",
      render: (_, record) => {
        const month = record.month > 9 ? record.month + "" : "0" + record.month;
        return dayjs(record.year + month).format("YYYY-MMM");
      },
      sorter: (a: TEV2DataType, b: TEV2DataType) => {
        if (a.year === b.year) {
          return b.month - a.month;
        }
        return b.year - a.year;
      },
      sortOrder: "ascend",
    },
    { title: "Song ID", key: "tev2SongId", dataIndex: "tev2SongId" },
    {
      title: "Video",
      dataIndex: "videoUrl",
      key: "videoUrl",
      render: (_, item) => {
        return (
          <div className="flex">
            <PlayCircleFilled
              className="play-icon"
              onClick={() => handlePreviewClick(item)}
            />
            <p className="ml-3">{item.vimeoId}</p>
          </div>
        );
      },
    },
    {
      title: "TEV2 banner",
      dataIndex: "tev2Banner",
      key: "tev2Banner",
      render: (v) =>
        v ? (
          <img className="TEV2-banner" src={v} alt="banner" />
        ) : (
          <div style={{ color: "gray" }}>No banner uploaded</div>
        ),
    },
    // {
    //   title: "Introduction banner",
    //   dataIndex: "introductionBanner",
    //   key: "introductionBanner",
    //   render: (v) =>
    //     v ? (
    //       <img className="TEV2-banner" src={v} alt="banner" />
    //     ) : (
    //       <div style={{ color: "gray" }}>No banner uploaded</div>
    //     ),
    // },
    {
      title: "Actions",
      render: (_, record) => (
        <div className="flex">
          <Button
            type="link"
            onClick={() => {
              setSelectedTEV2Video(record);
              setTEV2DrawerOpen(true);
              setIsCreate(false);
            }}
          >
            Edit
          </Button>
          <Button
            type="link"
            onClick={() => {
              if (record.seq) {
                setShowDeleteTev2Modal(true);
                setToBeDeletedTev2(record);
              }
            }}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  const CAPKColumns: ColumnsType<GGLDataType> = [
    {
      title: "Year month",
      dataIndex: "yearMonth",
      key: "yearMonth",
      render: (value: string) => dayjs(value).format("YYYY-MMM"),
      sorter: (a: GGLDataType, b: GGLDataType) =>
        dayjs(a.yearMonth).valueOf() - dayjs(b.yearMonth).valueOf(),
    },
    {
      title: "Lesson Title",
      dataIndex: "lessonTitle",
      key: "lessonTitle",
      sorter: (a: any, b: any) => a.lessonTitle?.localeCompare(b.lessonTitle),
    },
    {
      title: "CAP level",
      dataIndex: "capLevel",
      key: "capLevel",
      filters: capFilters,
      onFilter: (value: any, record: any) =>
        record.capLevel.indexOf(value) === 0,
      sorter: (a: any, b: any) => a.capLevel?.localeCompare(b.capLevel),
    },
    {
      title: "Action",
      dataIndex: "",
      key: "",
      width: 100,
      render: (_, record: GGLDataType) => (
        <div style={{ display: "flex" }}>
          <Button
            type="link"
            style={{ padding: 0, marginRight: 16 }}
            onClick={() => handleGGLEditClick(record)}
          >
            {record.yearMonth && !dayjs(record.yearMonth).isBefore(dayjs(), "month")
              ? "Edit"
              : "View"}
          </Button>
          {record.yearMonth && !dayjs(record.yearMonth).isBefore(dayjs(), "month") && (
            <Button
              type="link"
              style={{ padding: 0 }}
              onClick={() => {
                if (record.id) {
                  setShowDeleteGGLModal(true);
                  setToBeDeletedGGL(record);
                }
              }}
              loading={deleteLoading && record.id === selectGGLVideo?.id}
            >
              Delete
            </Button>
          )}
        </div>
      ),
    },
  ];

  const FAFUColumns: ColumnsType<GGLDataType> = [
    {
      title: "Year month",
      dataIndex: "yearMonth",
      key: "yearMonth",
      render: (value: string) => dayjs(value).format("YYYY-MMM"),
      sorter: (a: GGLDataType, b: GGLDataType) =>
        dayjs(a.yearMonth).valueOf() - dayjs(b.yearMonth).valueOf(),
    },
    {
      title: "Lesson Type",
      dataIndex: "lessonTitle",
      key: "lessonTitle",
      sorter: (a: any, b: any) => a.lessonTitle?.localeCompare(b.lessonTitle),
    },
    {
      title: "Action",
      dataIndex: "",
      key: "",
      width: 100,
      render: (_, record: GGLDataType) => (
        <div style={{ display: "flex" }}>
          <Button
            type="link"
            style={{ padding: 0, marginRight: 16 }}
            onClick={() => handleGGLEditClick(record)}
          >
            {record.yearMonth && !dayjs(record.yearMonth).isBefore(dayjs(), "month")
              ? "Edit"
              : "View"}
          </Button>
          {record.yearMonth && !dayjs(record.yearMonth).isBefore(dayjs(), "month") && (
            <Button
              type="link"
              style={{ padding: 0 }}
              onClick={() => {
                if (record.id) {
                  setShowDeleteGGLModal(true);
                  setToBeDeletedGGL(record);
                }
              }}
              loading={deleteLoading && record.id === selectGGLVideo?.id}
            >
              Delete
            </Button>
          )}
        </div>
      ),
    },
  ];

  const PLATColumns: ColumnsType<GGLDataType> = [
    {
      title: "Year month",
      dataIndex: "yearMonth",
      key: "yearMonth",
      render: (value: string) => dayjs(value).format("YYYY-MMM"),
      sorter: (a: GGLDataType, b: GGLDataType) =>
        dayjs(a.yearMonth).valueOf() - dayjs(b.yearMonth).valueOf(),
    },
    {
      title: "Lesson Title",
      dataIndex: "lessonTitle",
      key: "lessonTitle",
      sorter: (a: any, b: any) => a.lessonTitle?.localeCompare(b.lessonTitle),
    },
    {
      title: "Action",
      dataIndex: "",
      key: "",
      width: 100,
      render: (_, record: GGLDataType) => (
        <div style={{ display: "flex" }}>
          <Button
            type="link"
            style={{ padding: 0, marginRight: 16 }}
            onClick={() => handleGGLEditClick(record)}
          >
            {record.yearMonth && !dayjs(record.yearMonth).isBefore(dayjs(), "month")
              ? "Edit"
              : "View"}
          </Button>
          {record.yearMonth && !dayjs(record.yearMonth).isBefore(dayjs(), "month") && (
            <Button
              type="link"
              style={{ padding: 0 }}
              onClick={() => {
                if (record.id) {
                  setShowDeleteGGLModal(true);
                  setToBeDeletedGGL(record);
                }
              }}
              loading={deleteLoading && record.id === selectGGLVideo?.id}
            >
              Delete
            </Button>
          )}
        </div>
      ),
    },
  ];

  const handleGGLConfirm = (values: any) => {
    let GGLData = [];
    for (let index = 0; index < 3; index++) {
      GGLData.push({
        parentGuideUrl:
          index === 0
            ? twPdfFileName
            : index === 1
              ? hkPdfFileName
              : krPdfFileName,
        reviewPosterFileName: posterFileName,
        region: index === 0 ? "tw" : index === 1 ? "hk" : "kr",
        capLevel: selectVideo ? selectVideo.capLevel : values.capLevel,
        serviceType: "GGLA",
        videoUrl: values.videoFile
          ? `https://player.vimeo.com/video/${values.videoFile}`
          : undefined,
        yearMonth: selectVideo
          ? dayjs(selectVideo.yearMonth).format("YYYYMM")
          : dayjs(values.yearMonth).format("YYYYMM"),
        topicYearMonth: selectVideo
          ? `${dayjs(selectVideo.yearMonth)
            .startOf("month")
            .format("YYYY-MM-DD")}T00:00:00.000Z`
          : `${dayjs(values.yearMonth)
            .startOf("month")
            .format("YYYY-MM-DD")}T00:00:00.000Z`,
        priceInformation:
          index === 0
            ? "小孩週間每位 $300，週末每位 $380"
            : index === 1
              ? "小孩每位$120 ($120 per child)"
              : "어린이 1명: 11,000원",
        createTime: selectVideo ? selectVideo.createTime : undefined,
        seq: selectVideo ? selectVideo.seq[index] : undefined,
      });
    }
    console.log(GGLData);
    if (!selectVideo) {
      console.log("create ggl");
      createGGL({ variables: { GGLData } })
        .then((r) => {
          if (r.data && r.data.club_worldFamilyClub.count > 0) {
            gglRefetch()
              .then(() => {
                message.success(
                  renderAntDMessageConfig(
                    "Create Go, Go Live! content successful."
                  )
                );
                setShowGGLCreateDrawer(false);
              })
              .catch((e) => console.log(e));
          }
        })
        .catch((e) => console.log(e));
    } else {
      console.log("update ggl");
      updateGGL({ variables: { GGLData } })
        .then((r) => {
          if (r.data && r.data.club_worldFamilyClub.count > 0) {
            gglRefetch()
              .then(() => {
                message.success(
                  renderAntDMessageConfig(
                    "Update Go, Go Live! content successful."
                  )
                );
                setShowGGLEditDrawer(false);
              })
              .catch((e) => console.log(e));
          }
        })
        .catch((e) => console.log(e));
    }
  };

  const handleOHConfirm = (values: any) => {
    let ohData = [];

    if (uploadedFile) {
      uploadFile({
        variables: {
          blobs: [
            {
              file: uploadedFile?.originFileObj,
              path: AfBlobPath.VesPdf,
            },
          ],
        },
      }).catch((e) => console.log(e));
    }

    for (let index = 0; index < 3; index++) {
      ohData.push({
        parentGuideUrl: hkPdfFileName,
        reviewPosterFileName: undefined,
        region: index === 0 ? "tw" : index === 1 ? "hk" : "kr",
        capLevel: "NONE",
        serviceType: "VEFB",
        videoUrl: values.videoFile
          ? `https://player.vimeo.com/video/${values.videoFile}`
          : undefined,
        yearMonth: selectVideo
          ? dayjs(selectVideo.yearMonth).format("YYYYMM")
          : dayjs(values.yearMonth).format("YYYYMM"),
        topicYearMonth: selectVideo
          ? `${dayjs(selectVideo.yearMonth)
            .startOf("month")
            .format("YYYY-MM-DD")}T00:00:00.000Z`
          : `${dayjs(values.yearMonth)
            .startOf("month")
            .format("YYYY-MM-DD")}T00:00:00.000Z`,
        priceInformation: index === 2 ? "무료" : "免費",
        createTime: selectVideo ? selectVideo.createTime : undefined,
        seq: selectVideo ? selectVideo.seq[index] : undefined,
      });
    }
    console.log(ohData);
    if (!selectVideo) {
      console.log("create open house");
      createGGL({ variables: { GGLData: ohData } })
        .then((r) => {
          if (r.data && r.data.club_worldFamilyClub.count > 0) {
            ohRefetch()
              .then(() => {
                message.success(
                  renderAntDMessageConfig(
                    "Create Open house content successful."
                  )
                );
                setShowOhCreateDrawer(false);
              })
              .catch((e) => console.log(e));
          }
        })
        .catch((e) => console.log(e));
    } else {
      console.log("update open house");
      updateGGL({ variables: { GGLData: ohData } })
        .then((r) => {
          if (r.data && r.data.club_worldFamilyClub.count > 0) {
            ohRefetch()
              .then(() => {
                message.success(
                  renderAntDMessageConfig(
                    "Update Open house content successful."
                  )
                );
                setShowOhEditDrawer(false);
              })
              .catch((e) => console.log(e));
          }
        })
        .catch((e) => console.log(e));
    }
  };

  const RADIO_OPTIONS: RadioOption[] = [
    { label: "Go, Go Live!", value: "ggla" },
    { label: "Open House", value: "oh" },
    { label: "TEV2", value: "te" },
    { label: "CAP Kids!", value: "capk" },
    { label: "Family Fun!", value: "fafu" },
    { label: "Playtime!", value: "plyt" },
  ];

  useEffect(() => {
    if (currentUser?.afUserMarkets) {
      var hasOther = currentUser?.afUserMarkets.some((item) => ["TW", "HK", "KR"].includes(item?.market ?? ""));
      var hasJP = currentUser?.afUserMarkets.some((item) => ["JP"].includes(item?.market ?? ""));

      const visibleOptions = [
        ...(hasOther ? RADIO_OPTIONS.slice(0, 3) : []),
        ...(hasJP ? RADIO_OPTIONS.slice(3, 6) : []),
      ];

      setOprions(visibleOptions);

      if (hasJP && !hasOther) setSelectType("capk");
      else setSelectType("ggla");
    }
  }, [currentUser]);

  useEffect(() => {
    setSelectedService(ServiceTypes.CLUB_APP);
    setSelectSubItem("Go, Go Live!");
    gglRefetch();
  }, []);

  useEffect(() => {
    if (gglData && gglData.goGoLiveParentGuideList) {
      const data: GGLDataType[] = gglData.goGoLiveParentGuideList.map((item) => ({
        id: item.goGoLiveParentGuideId,
        yearMonth: item.yearAndMonth,
        lessonTitle: item.lessonTitle,
        capLevel: item.levelName,
        vimeoId: item.previewVideoVimeoId,
        vimeoUrl: item.previewVideoUrl,
      }));

      if (selectType.toUpperCase() === "GGLA") setDisplayGglData(data);
      else if (selectType.toUpperCase() === "CAPK") setDisplayCAPKData(data);
      else if (selectType.toUpperCase() === "FAFU") setDisplayFAFUData(data);
      else if (selectType.toUpperCase() === "PLYT") setDisplayPLYTData(data);
    }
  }, [gglData]);

  useEffect(() => {
    if (ohData && ohData.club_worldFamilyClub_goGoLivePromotion?.nodes) {
      const originalData = ohData.club_worldFamilyClub_goGoLivePromotion?.nodes;
      let newData = [];
      let transformData: DataType[] = [];
      for (let i = 0; i < originalData.length; i += 3) {
        const chunk = originalData.slice(i, i + 3);
        newData.push(chunk);
      }
      newData.forEach((arr, i) => {
        const map = arr.map((item) => parseInt(renderDecodedId(item.id)));
        transformData.push({
          id: i.toString(),
          type: arr[0].serviceType,
          yearMonth: arr[0].topicYearMonth,
          capLevel: "None",
          vimeoId: arr[0].videoUrl?.split("video/")[1],
          fileNameHK: arr[0].parentGuideUrl?.split("?")[0].split("ves-pdf/")[1],
          fileNameKR: null,
          fileNameTW: null,
          fileNamePoster: null,
          seq: map,
          createTime: arr[0].createTime,
        });
      });
      setDisplayOhData(transformData);
    }
  }, [ohData]);

  useEffect(() => {
    if (TEV2Data) {
      setDisplayTEData(TEV2Data.tev2MonthlySongList);
    }
  }, [TEV2Data]);

  useEffect(() => {
    if (selectType === "ggla") {
      setTabColumns(gglColumns);
      setTabData(displayGglData);
    } else if (selectType === "oh") {
      setTabColumns(ohColumns);
      setTabData(displayOhData);
    } else if (selectType === "te") {
      setTabColumns(TEColumns);
      setTabData(displayTEData);
    } else if (selectType === "capk") {
      setTabColumns(CAPKColumns);
      setTabData(displayCAPKData);
    } else if (selectType === "fafu") {
      setTabColumns(FAFUColumns);
      setTabData(displayFAFUData);
    } else if (selectType === "plyt") {
      setTabColumns(PLATColumns);
      setTabData(displayPLYTData);
    }

  }, [selectType, displayGglData, displayOhData, displayTEData, displayCAPKData, displayFAFUData, displayPLYTData]);

  if (userProgramsError || ohDataError || gglDataError) {
    message.error(
      renderAntDMessageConfig(
        "Something went wrong. Please contact your system administrator."
      )
    );
  }

  if (userProgramsLoading || ohDataLoading) {
    return <Spinner />;
  }

  if (
    userPrograms &&
    !userPrograms.wf_adminFirst_afUserProgram?.edges?.find(
      (item) => item.node.afProgram?.programName === "Go, Go Live!"
    )
  ) {
    return <NoPermission />;
  }

  return (
    <>
      <div>
        <div className="header" style={{ backgroundColor: Colors.white }}>
          <p className="header-title" style={{ color: Colors.darkGrey }}>
            VES
          </p>
        </div>
        <div className="ggl-content-container">
          <div className="ggl-content-inner-container">
            <div className="ggl-content-header">
              <Radio.Group
                optionType="button"
                options={options}
                value={selectType}
                onChange={(e) => {
                  setSelectVideo(undefined);
                  setSelectType(e.target.value);
                }}
              />
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setSelectVideo(undefined);
                  setUploadedFile(undefined);
                  selectType === "ggla" || selectType === "capk" || selectType === "fafu" || selectType === "plyt"
                    ? navigate(`/club-app/ves/${selectType}/create`) //setShowGGLCreateDrawer(true)
                    : selectType === "oh"
                      ? setShowOhCreateDrawer(true)
                      : setTEV2DrawerOpen(true);
                  setIsCreate(true);
                }}
              >
                Create New
              </Button>
            </div>
            <div className="ggl-table-container">
              <Table
                rowKey="id"
                columns={tabColumns}
                dataSource={tabData}
                pagination={{ hideOnSinglePage: true }}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={showPreview}
        onCancel={onCancel}
        title={selectPreview?.vimeoId}
        footer={null}
        width={690}
        forceRender
      >
        {selectPreview && (
          <iframe
            ref={vimeoRef}
            src={`https://player.vimeo.com/video/${selectPreview?.vimeoId}`}
            width="640"
            height="360"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen={false}
            title={selectPreview?.vimeoId}
          ></iframe>
        )}
      </Modal>
      <GeneralModal
        open={showDeleteGGLModal}
        close={closeDeleteGGLModal}
        isConfirm={false}
        isDeletion
        width={417}
        handleDelete={() => handleGGLDelete(toBeDeletedGGL?.id || 0)}
        text={selectType === "capk" ? `Are you sure you want to delete the ${dayjs(toBeDeletedGGL?.yearMonth).format("YYYY-MMM")} ${toBeDeletedGGL?.lessonTitle} Parent Guide?`
          : selectType === "fafu" ? `Are you sure you want to delete the ${dayjs(toBeDeletedGGL?.yearMonth).format("YYYY-MMM")} Family Fun! ${toBeDeletedGGL?.lessonTitle} Parent Guide?`
            : selectType === "plyt" ? `Are you sure you want to delete the ${dayjs(toBeDeletedGGL?.yearMonth).format("YYYY-MMM")} Playtime! ${toBeDeletedGGL?.lessonTitle} Parent Guide?`
              : `Are you sure you want to delete the ${dayjs(toBeDeletedGGL?.yearMonth).format("YYYY-MMM")} monthly video?`
        }
      />
      <GeneralModal
        open={showDeleteTev2Modal}
        close={closeDeleteTev2Modal}
        isConfirm={false}
        isDeletion
        width={417}
        handleDelete={() => handleTEV2Delete(toBeDeletedTev2?.seq || 0)}
        text={`Are you sure you want to delete the ${dayjs(
          toBeDeletedTev2?.year +
          (toBeDeletedTev2 && toBeDeletedTev2?.month > 9
            ? toBeDeletedTev2?.month + ""
            : "0" + toBeDeletedTev2?.month)
        ).format("YYYY-MMM")} monthly video?`}
      />
      <GoGoLiveCreateDrawer
        show={showGGLCreateDrawer}
        form={gglCreateForm}
        setShow={setShowGGLCreateDrawer}
        handleConfirm={handleGGLConfirm}
        setHkPdfFileName={setHkPdfFileName}
        setKrPdfFileName={setKrPdfFileName}
        setTwPdfFileName={setTwPdfFileName}
        setPosterFileName={setPosterFileName}
        btnLoading={createLoading}
      />
      <GoGoLiveEditDrawer
        show={showGGLEditDrawer}
        form={gglEditForm}
        setShow={setShowGGLEditDrawer}
        setSelectVideo={setSelectVideo}
        selectVideo={selectVideo}
        handleConfirm={handleGGLConfirm}
        setHkPdfFileName={setHkPdfFileName}
        setKrPdfFileName={setKrPdfFileName}
        setTwPdfFileName={setTwPdfFileName}
        setPosterFileName={setPosterFileName}
        btnLoading={updateLoading}
      />
      <OpenHouseCreateDrawer
        show={showOhCreateDrawer}
        form={ohCreateForm}
        setShow={setShowOhCreateDrawer}
        handleConfirm={handleOHConfirm}
        setHkPdfFileName={setHkPdfFileName}
        setUploadedFile={setUploadedFile}
        btnLoading={createLoading}
      />
      <OpenHouseEditDrawer
        show={showOhEditDrawer}
        form={ohEditForm}
        setShow={setShowOhEditDrawer}
        setSelectVideo={setSelectVideo}
        selectVideo={selectVideo}
        handleConfirm={handleOHConfirm}
        setHkPdfFileName={setHkPdfFileName}
        setUploadedFile={setUploadedFile}
        btnLoading={updateLoading}
      />
      <TEV2Drawer
        setTEV2DrawerOpen={setTEV2DrawerOpen}
        tEV2DrawerOpen={tEV2DrawerOpen}
        isCreate={isCreate}
        TEV2Refetch={TEV2Refetch}
        selectedTEV2Video={selectedTEV2Video}
        setSelectedTEV2Video={setSelectedTEV2Video}
      />
    </>
  );
};

export default GoGoLive;
